module.exports = __webpack_public_path__ + "img/indexImg.52df9ee6.png";